import type { ReactNode } from "react";
import { Button, Container, Grid, TextField, useMediaQuery } from "@mui/material";
import ArticleListStore from "components/molecules/ArticleListStore";
import PageTitle from "components/molecules/PageTitle";
import SubTitleCommande from "components/molecules/SubTitleCommande";
import type Commande from "models/Commande";
import type { User } from "@sdeapps/react-core";
import SaveIcon from "@mui/icons-material/Save";
import type CommandeArticleFormModel from "models/CommandeArticleFormModel";

interface StoreManagerCommandePageTemplateProps {
  demandeur: User | undefined;
  articlesList: Array<CommandeArticleFormModel>;
  updateCommande: () => Promise<void>;
  isSending: boolean;
  setArticlesList: (arg: Array<CommandeArticleFormModel>) => void;
  commentaire: string;
  setCommentaire: (value: string) => void;
  commande: Commande;
}

function StoreManagerCommandePageTemplate({
  demandeur,
  articlesList,
  updateCommande,
  isSending,
  setArticlesList,
  commentaire,
  setCommentaire,
  commande,
}: Readonly<StoreManagerCommandePageTemplateProps>): ReactNode {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <>
      <PageTitle title={demandeur?.displayName ?? commande.demandeurNomComplet ?? "???"}>
        <SubTitleCommande demandeur={demandeur} commande={commande}>
          <Button
            variant="contained"
            disabled={isSending || articlesList.some((value) => value.statutArticle == null)}
            onClick={() => {
              void updateCommande();
            }}
            endIcon={<SaveIcon />}
            loading={isSending}
            loadingPosition="end">
            Mettre à jour{!isSmallScreen && " la commande"}
          </Button>
        </SubTitleCommande>
      </PageTitle>
      <Container maxWidth={false}>
        <Grid container spacing={2} sx={{ mb: 4 }}>
          <ArticleListStore articlesList={articlesList} setArticlesList={setArticlesList} />
          <Grid size={12}>
            <TextField
              value={commentaire}
              onChange={(e) => {
                setCommentaire(e.target.value);
              }}
              multiline
              fullWidth
              label="Commentaire du Magasinier"
              placeholder="Saisissez votre message ici..."
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default StoreManagerCommandePageTemplate;
